import { CreateAccountDto, CreateAccountDtoImpl } from './createaccountdto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class CreateAccountBuilder {
    constructor(private createAccountResponse: any) {
        if(createAccountResponse === undefined)
        {
            throw new NoDataException("Registration data doesnt exists");
        }
    }

    buildAll(): CreateAccountDto {
        return this.parseCreateAccountResponse();
    }

    private parseCreateAccountResponse(): CreateAccountDto
    {
        let createAccountDto = new CreateAccountDtoImpl();

        createAccountDto.setRespDesc(this.createAccountResponse.respDesc);
        createAccountDto.setClientTxnId(this.createAccountResponse.clientTxnId);
        createAccountDto.setSrvType(this.createAccountResponse.srvType);
        createAccountDto.setSecToc(this.createAccountResponse.secToc);
       
        return createAccountDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/createaccount/createaccountbuilder.ts